import * as React from 'react'
import styles from './banner.styl'
import img from 'assets/img/banner.png'

const Banner = () => (

  // eslint-disable-next-line react/jsx-no-target-blank
  <a
    href="https://intaward.org/your-story/"
    title="The Duke of Edinburgh's International Award Foundation - Share your award story"
    target="blank"
    className={styles.link}
  >

    <img
      src={img}
      width="100%"
      alt="The Duke of Edinburgh's International Award Foundation - Share your award story"
    />

  </a>

)

export default Banner
